import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_money = _resolveComponent("money")!
  const _component_download_receipt_btn = _resolveComponent("download-receipt-btn")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, _mergeProps({
    columns: _ctx.columns,
    rows: _ctx.charges,
    "row-key": "id",
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
    loading: _ctx.isLoading
  }, _ctx.$attrs, {
    "binary-state-sort": "",
    onRequest: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event.pagination))
  }), {
    top: _withCtx(() => [
      _createVNode(_component_q_input, {
        modelValue: _ctx.keyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
        placeholder: "Name or file ref no.",
        "clear-icon": "fa fa-times",
        clearable: "",
        debounce: 500,
        style: {"min-width":"320px"},
        autocomplete: "no",
        filled: "",
        dense: "",
        onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = ''))
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "fa fa-search" })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    "body-cell-description": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: {name: 'client_profile', params: {clientId: props.row.clientId}},
            class: "link",
            title: "View Profile"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.value), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-subTotal": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_money, {
            currency: props.row.currency,
            amount: props.value
          }, null, 8, ["currency", "amount"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-tax": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_money, {
            currency: props.row.currency,
            amount: props.value
          }, null, 8, ["currency", "amount"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-total": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_money, {
            currency: props.row.currency,
            amount: props.value
          }, null, 8, ["currency", "amount"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-charged": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$filters.date(props.value)), 1)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-actions": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_download_receipt_btn, {
            "charge-id": props.row.id
          }, null, 8, ["charge-id"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 1
  }, 16, ["columns", "rows", "pagination", "loading"]))
}